import './ReportePorCerealView.scss'

import React, { Component } from 'react'
import { Container } from 'react-bootstrap'

import { TABLE_REPORTE_ESTADO_POR_CEREAL_TRIGO,
  TABLE_REPORTE_ESTADO_POR_CEREAL_SOJA,
  TABLE_REPORTE_ESTADO_POR_CEREAL_MAIZ,
  TABLE_REPORTE_ESTADO_POR_CEREAL_CEBADAFO,
  TABLE_REPORTE_ESTADO_POR_CEREAL_CEBADACE,
  TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETGC,
  TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETSJ,
  TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETSC,
  TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETCG,
  TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETCS,
  TABLE_TOTAL_ESTADO_POR_CEREAL_TRIGO,
  TABLE_TOTAL_ESTADO_POR_CEREAL_SOJA,
  TABLE_TOTAL_ESTADO_POR_CEREAL_MAIZ,
  TABLE_TOTAL_ESTADO_POR_CEREAL_CEBADAFO,
  TABLE_TOTAL_ESTADO_POR_CEREAL_CEBADACE,
  TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETGC,
  TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETSJ,
  TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETSC,
  TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETCG,
  TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETCS
} from '../../../config/tables'
import MuiTable from '../../Forms/SharedComponents/containers/MuiTable'

class ReportePorCerealView extends Component {
  render () {
    return (
      <Container fluid>
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_CEREAL_TRIGO} />
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_CEREAL_SOJA} />
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_CEREAL_MAIZ} />
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_CEREAL_CEBADAFO} />
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_CEREAL_CEBADACE} />
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETGC} />
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETSJ} />
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETSC} />
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETCG} />
        <MuiTable id={TABLE_TOTAL_ESTADO_POR_CEREAL_PELLETCS} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_CEREAL_TRIGO} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_CEREAL_SOJA} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_CEREAL_MAIZ} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_CEREAL_CEBADAFO} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_CEREAL_CEBADACE} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETGC} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETSJ} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETSC} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETCG} />
        <br />
        <MuiTable id={TABLE_REPORTE_ESTADO_POR_CEREAL_PELLETCS} />
      </Container>
    )
  }
}
export default ReportePorCerealView
